import React, { useState } from 'react';
import * as Yup from 'yup';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import axios from 'axios';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';
import { useClientContext } from '../../context/client_context';
import { useConstantsContext } from '../../context/constants_context';
import SearchList from './SearchList';

export default function SearchClient() {
  const { setClientRefId, refreshClientValues, clearContext } = useClientContext();
  const { setClients } = useConstantsContext();
  const [showList, setShowList] = useState(false);
  const [noOfRecords, setNoOfRecords] = useState(-1);
  const [download, setDownload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();

  const PersonalDetailsSchema = Yup.object().shape({
    surname: Yup.string().max(50, 'Surname is too Long!')
  });

  const formik = useFormik({
    initialValues: {
      lastName: '',
      idNumber: '',
      policyNo: '',
      school: ''
    },
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      setShowList(false);
      search(values);
      // handleSearch(values);
    }
  });

  const recordsReturned = (data) => {
    console.log('check my data', data);
    if (data.length > 0) {
      setClients(data);
      setShowList(true);
      setNoOfRecords(data.length);
    } else {
      setNoOfRecords(0);
    }
  };

  const search = async (values) => {
    if (values.lastName === '' && values.policyNo === '' && values.school === '') {
      notifyPopup(`Please enter Criteria to Search e.g. Enter Surname!`, 'error');
      return;
    }
    let strValues = '';
    let searchKeys = 1;
    if (values.lastName !== '') {
      strValues = values.lastName;
      searchKeys = 1;
    }
    if (values.policyNo !== '') {
      strValues = values.policyNo;
      searchKeys = 2;
    }
    if (values.school !== '') {
      strValues = values.school;
      searchKeys = 6;
    }
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      params: {
        searchKey: searchKeys,
        strValue: strValues,
        firstName: 'temp'
      }
    };
    setLoading(true);
    // clearContext();

    axios.get(`${baseUrl}/api/client/searchadvanced`, config).then(
      (result) => {
        setLoading(false);
        if (result.data.totalRecordCount === 0) {
          setNoOfRecords(0);
          setShowList(false);
          setDownload(false);
          notifyPopup(
            `No Members Found with Specified Criteria: ${result.replyMessage}`,
            'success'
          );
        } else {
          setDownload(true);
          recordsReturned(result.data);
        }
      },
      (error) => {
        console.log('Fatal Error is', error);
        notifyPopup(`Fatal Error in Retrieving Members Search List!: ${error}`, 'error');
      }
    );
  };

  const downloadDocument = () => {
    if (
      formik.values.lastName === '' &&
      formik.values.policyNo === '' &&
      formik.values.school === ''
    ) {
      notifyPopup(`Please enter Criteria to Search e.g. Enter Surname!`, 'error');
      return;
    }
    let strValues = '';
    let searchKeys = 1;
    if (formik.values.lastName !== '') {
      strValues = formik.values.lastName;
      searchKeys = 1;
    }
    if (formik.values.policyNo !== '') {
      strValues = formik.values.policyNo;
      searchKeys = 2;
    }
    if (formik.values.school !== '') {
      strValues = formik.values.school;
      searchKeys = 6;
    }
    setLoading(true);
    const filename = `SearchResults_${moment().format('DD-MMM-YYYY')}.xls`;
    fetch(`${baseUrl}/api/report/getnew/SearchResults/xls/${strValues}/${searchKeys}/0/0/0`)
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Downloading Search Results!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleNewClient = () => {
    console.log('entered here');
    setClientRefId(-1);
    clearContext();
    openNew();
  };

  const handleClear = () => {
    console.log('entered here');
    setClientRefId(-1);
    clearContext();
    formik.setFieldValue('lastName', '');
    formik.setFieldValue('policyNo', '');
    formik.setFieldValue('school', '');
  };

  const openNew = () => {
    navigate('/clientportfolio/registerclient/00000000-0000-0000-0000-000000000000');
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography component="span" variant="h6" gutterBottom>
                Search for Members
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="lastName" label="Surname" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="idNumber" label="ID #" disabled />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="policyNo" label="EC #" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="school" label="School" />
                </Grid>
              </Grid>
              <Grid container margin={2} direction="row" justifyContent="right" alignItems="right">
                <Grid item xs={12} sm={2}>
                  <Button
                    type="submit"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    // onClick={() => search()}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    startIcon={<ClearIcon />}
                    onClick={() => handleClear()}
                  >
                    Clear
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => handleNewClient()}
                  >
                    New Client
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} ml={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    disabled={!download}
                    startIcon={<CloudDownloadIcon />}
                    onClick={() => downloadDocument()}
                  >
                    Download
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
      {showList === false && noOfRecords === 0 && (
        <div style={{ margin: '10px 300px', color: 'red', fontWeight: '800' }}>
          No clients exists for selected criteria...
          {/* {notifyPopup(`No clients exists for selected criteria...`, 'No Clients Found')} */}
        </div>
      )}
      {showList === true && <SearchList />}
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </>
  );
}
